export default __webpack_public_path__ + "static/media/DNo.11-4.809ac36c.jpg";